export class NewParcourCertificate {
  constructor(
    public name: string,
    public shortname: string,
    public fullname: string,
    public displayname: string,
    public startdate: number,
    public enddate: number,
    public urlCertificat: string,
    public plateforme: string,
    public description: string,
    public cohort: string,
    public externalId?: string,
    public category?: string,
    public id?: number,
    public urlImage?: string,
    public codeparcour?: string
  ) { }
}
